import React, { useEffect, useMemo } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../_redux/project/projectAction";
import * as uiHelpers from "../ProjectUIHelpers";

import {
  currencyFormatter,
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
} from "../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../../_metronic/_partials/controls";
import { useProjectUIContext } from "../ProjectUIContext";
import { RoleChecker } from "../../../../RoleChecker";
// import { ToastContainer } from 'react-toastify';

const ProjectTable = (props) => {
  // Project UI Context
  const projectUIContext = useProjectUIContext();
  const projectUIProps = useMemo(() => {
    return {
      queryParams: projectUIContext.queryParams,
      setQueryParams: projectUIContext.setQueryParams,
      openEditProjectPage: projectUIContext.openEditProjectPage,
      openManageProjectPage: projectUIContext.openManageProjectPage,
    };
  }, [projectUIContext]);

  // Getting curret state of project list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.project }),
    shallowEqual
  );

  const { totalCount, entities, listLoading } = currentState;

  const dispatch = useDispatch();
  useEffect(() => {
    //Requset ke Branch Action
    dispatch(actions.fetchProjects(projectUIProps.queryParams));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectUIProps.queryParams, dispatch]);

  const allowEdit = RoleChecker("Edit", "project");

  // Table columns
  const columns = [
    {
      dataField: "name",
      text: "Name",
    },
    {
      dataField: "description",
      text: "Deskripsi",
    },
    {
      dataField: "project_expense_amount",
      text: "Total Penyaluran",
      formatter: (cell) => {
        return currencyFormatter(cell);
      },
    },
    {
      dataField: "target_revenue",
      text: "Target Penerimaan",
      headerClasses: "text-right",
      classes: "text-right",
      formatter: (cell) => {
        return currencyFormatter(cell);
      },
    },
    {
      dataField: "action",
      text: "Actions",
      formatter: columnFormatters.ActionsColumnFormatter,
      formatExtraData: {
        openEditProjectPage: projectUIProps.openEditProjectPage,
        openManageProjectPage: projectUIProps.openManageProjectPage,
        allowEdit,
      },
      classes: "text-right pr-0",
      headerClasses: "text-right pr-3",
      style: {
        minWidth: "100px",
      },
    },
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: projectUIProps.queryParams.pageSize,
    page: projectUIProps.queryParams.pageNumber,
  };

  return (
    <>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              isLoading={listLoading}
              paginationProps={paginationProps}
            >
              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                bordered={false}
                remote
                keyField="uuid"
                data={entities === null ? [] : entities}
                columns={columns}
                // defaultSorted={uiHelpers.defaultSorted}
                onTableChange={getHandlerTableChange(
                  projectUIProps.setQueryParams
                )}
                // selectRow={getSelectRow({
                //   entities,
                //   ids: productsUIProps.ids,
                //   setIds: productsUIProps.setIds,
                // })}
                {...paginationTableProps}
              >
                <PleaseWaitMessage entities={entities} />
                <NoRecordsFoundMessage entities={entities} />
              </BootstrapTable>
            </Pagination>
          );
        }}
      </PaginationProvider>
    </>
  );
};

export default ProjectTable;
